import React from 'react';
import { CommonToolsWrapper } from './styled';
import UnitToggle from '@components/common/UnitToggle';
import { useAtom } from 'jotai';
import { unitAtom } from '@src/components/metrics-panel-hz/atoms';
import DimensionsSelectorPopup from '@src/components/dimension-panel-hz/dimensionSelectorPopup';
import ShowHoc from '../ShowHoc';
import WidgetControl from '@src/components/widget-panel/control';
import MetricControl from './MetricControl';
import PercentileSelector from './PercentileSelector';
import MetricSelector from '@src/components/dimension-panel-hz/header/MetricSelector';
import MetricsPopup from '@src/components/metrics-panel-hz/control-panel/MetricsPopup';

function CommonTools({ showControl }) {
  const [unit, setUnit] = useAtom(unitAtom);
  const handleUnitChange = (value) => {
    setUnit(value);
  };

  return (
    <CommonToolsWrapper>
      <ShowHoc condition={showControl.widget}>
        <WidgetControl />
      </ShowHoc>
      <ShowHoc condition={showControl.metric && showControl.dimension}>
        <MetricControl />
      </ShowHoc>
      <ShowHoc condition={showControl.metric && !showControl.dimension}>
        <MetricsPopup />
      </ShowHoc>
      <ShowHoc condition={!showControl.metric && showControl.dimension}>
        <MetricSelector />
      </ShowHoc>
      <ShowHoc condition={showControl.percentile}>
        <PercentileSelector />
      </ShowHoc>
      <ShowHoc condition={showControl.dimension}>
        <DimensionsSelectorPopup />
      </ShowHoc>
      <ShowHoc condition={showControl.metric || showControl.dimension || showControl.widget}>
        <UnitToggle selectedUnit={unit} onChange={handleUnitChange} />
      </ShowHoc>
    </CommonToolsWrapper>
  );
}

export default CommonTools;
